import axios from "axios";
import Swal from "sweetalert2";

const FormulaMixin = {
    methods: {
        fireSimpleErrorAlert: function(text) {
            return Swal.fire({
                text,
                icon: "error",
                title: "Error",
            });
        },
        validateCheckPriceForm: function(event, formula) {
            const errors = [];

            if (!formula || formula.length <= 0) {
                errors.push({
                    field: "formula",
                    message: "Formula is required.",
                });
            }

            if (!event || event.length <= 0) {
                errors.push({
                    field: "event",
                    message: "Event is required.",
                });
            }

            if (event && event.length > 0) {
                try {
                    JSON.parse(event);
                } catch (e) {
                    errors.push({
                        field: "event",
                        message: "Event is not a valid JSON.",
                    });
                }
            }

            return errors;
        },
        getPipelineVariable: async function(variableId, pipelineSlug, formulaId) {
            try {
                const {data} = await axios.get(
                    `/api/formula/${pipelineSlug}/${formulaId}`
                );

                return data.formula_variables.find(
                    (variable) => variable.id === variableId
                );
            } catch (error) {
                throw new Error("GetPipelineVariableFailure", {
                    cause: {
                        field: "xhr",
                        message: `Failed to fetch ${pipelineSlug} variable ${variableId} . \nPlease try again later`,
                    },
                });
            }
        },
        updateVariableLookupValues: async function(pipelineSlug, formulaId, variableId, payload) {
            try {
                const {data} = await axios.post(
                    `/api/formula/${pipelineSlug}/${formulaId}/variable/${variableId}/lookups`,
                    payload
                );

                return data.message === 'Succeed';
            } catch (error) {
                console.log(error);
                throw new Error("LookupValuesUpdateFailure", {
                    cause: [
                        {
                            field: "xhr",
                            message:
                                "Lookup values update failed to execute. \nPlease try again later",
                        },
                    ],
                });
            }
        },
    },
};

export default FormulaMixin;
